import { call, put, takeLatest, select } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import { GET } from "../../api";
import {
    FETCH_SHOW_MORE_COLLECTION_LIST,
    SET_SHOW_MORE_COLLECTION_LIST,
} from "../actions";
import { setTotalCount } from '../slices/totalCountSlice';



const getSelectedId = (state) => state.selectItemDrawerMenu.selectedId;

const getCurrentPage = (state) => state.currentPage.currentPage;

const getSelectColorId = (state) => state.selectColor.selectColor

const getSearchInputContent = (state) => state.searchInputContent.searchInputContent;

const getSelectedSpaceId = (state) => state.selectSpace.selectSpace

const getFreeState = (state) => state.freeCheckbox



export function* FetchShowMoreCollectionSaga() {

    const selectedId = yield select(getSelectedId);
    const currentPage = yield select(getCurrentPage);
    const selectedColorId = yield select(getSelectColorId);
    const selectedSpaceId = yield select(getSelectedSpaceId);
    const searchInputContent = yield select(getSearchInputContent);
    const freeState = yield select(getFreeState);



    try {


        const url = ApiRouts.API_SHOW_MORE_COLLECTION({
            freeState,
            selectedId,
            selectedColorId,
            selectedSpaceId,
            searchInputContent,
            currentPage
        })

        const response = yield call(GET, url, {});

        if (response) {

            yield put({
                type: SET_SHOW_MORE_COLLECTION_LIST,
                payload: response.data
            });


            yield put(setTotalCount(response.data.meta.total));

        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* showMoreCollectionSaga() {
    yield takeLatest(FETCH_SHOW_MORE_COLLECTION_LIST, FetchShowMoreCollectionSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default showMoreCollectionSaga;
